module.exports = __webpack_public_path__ + "static/media/microsoftDark.8b5afe66.svg";